export default __webpack_public_path__ + "static/media/Cuprum-SemiBoldItalic.7689ebb2.ttf";